// extracted by mini-css-extract-plugin
module.exports = {"bodyInput":"CourseFeedbackForm_bodyInput__0TtN_","submitButton":"CourseFeedbackForm_submitButton__vLdJc","ratingContainer":"CourseFeedbackForm_ratingContainer__AF_0R"};